import React, { useEffect, useLayoutEffect, useRef } from "react";
import useComponentSize from "@rehooks/component-size";
import { EChartsOption, getInstanceByDom, init } from "echarts";

import { LoadingChartIndicator } from "./LoadingChartIndicator";

export interface IChartProps {
    option: EChartsOption;
}

export const BaseChart: React.FC<IChartProps> = ({ option }) => {
    const chartRef = useRef<HTMLDivElement>(null);
    const size = useComponentSize(chartRef);

    useEffect(() => {
        if (chartRef.current) {
            init(chartRef.current, "dark");
        }
    }, [chartRef]);

    useEffect(() => {
        const chart = chartRef.current && getInstanceByDom(chartRef.current);
        if (chart) {
            chart.resize();
        }
    }, [chartRef, size]);

    useEffect(() => {
        if (chartRef.current) {
            const chart = getInstanceByDom(chartRef.current);
            chart?.setOption(option);
        }
    }, [option]);

    const onVisibilityChange = () => {
        if (document.visibilityState === "visible") {
            const chart =
                chartRef.current && getInstanceByDom(chartRef.current);
            chart?.setOption(option);
            chart?.resize();
        }
    };

    useLayoutEffect(() => {
        document.addEventListener("visibilitychange", onVisibilityChange);

        return () =>
            document.removeEventListener(
                "visibilitychange",
                onVisibilityChange,
            );
    }, []);

    if (!option?.series) {
        return <LoadingChartIndicator />;
    }

    return (
        <div style={{ height: "100%", width: "100%" }}>
            <div
                ref={chartRef}
                style={{
                    width: "100%",
                    // HACK: this is to allow resizing https://github.com/recharts/recharts/issues/1767
                    height: "99%",
                }}
            />
        </div>
    );
};
